import React from 'react'
import { connect } from 'react-redux'

import OptionList from '../option-list'
import { sortOptions } from '../../../utils/option-sort'

const mapStateToProps = (state) => {
    return {
        options: sortOptions(state.adminCuisines)
    }
}

const Cuisines = ({ options }) => {
    return (
        <OptionList
            endpoint="admin/cuisines"
            options={options}
            singular="Cuisine" />
    )
}

export default connect(mapStateToProps)(Cuisines)
